import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import useQuery from '../../util/hooks/useQuery';
import { EmptyPage } from '../../components/EmptyPage/EmptyPage';
import { PAGES } from '../../constants/pages';
import SectionLoader from '../../components/SectionLoader/SectionLoader';
import { salesAssistedGetInviteUser } from '../../store/actions/salesAssisted/salesAsssistedActions';
import { storeInSessionStorage } from '../../util/helpers/sessionStorageHelper';
import { EMAIL } from '../../constants/sessionStorage';
import ErrorModal from '../../components/Modals/ErrorModal/ErrorModal';

const SalesAssistedInviteUser = () => {
  const query = useQuery();
  const dispatch = useDispatch();
  const history = useHistory();
  const invitationToken = query['invitation-token'];
  const [isErrorMessageModalOpen, setIsErrorMessageModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const onSuccess = (data) => {
    const { IsNew, Email } = data;
    if (Email) {
      storeInSessionStorage(EMAIL, Email);
      history.push(PAGES.LOGIN_PATH);
    }
    if (IsNew) {
      history.push(PAGES.SET_PASSWORD);
    }
  };

  const onError = (errorMsg) => {
    setErrorMessage(errorMsg);
    setIsErrorMessageModalOpen(true);
  };
  useEffect(() => {
    if (!invitationToken) {
      history.push(PAGES.BASE);
    }
    if (invitationToken) {
      dispatch(
        salesAssistedGetInviteUser({
          data: {
            invitationToken,
          },
          onSuccess,
          onError,
        }),
      );
    }
  }, []); //eslint-disable-line

  return (
    <EmptyPage>
      <SectionLoader isLoading />
      {isErrorMessageModalOpen && (
        <ErrorModal
          isOpen={isErrorMessageModalOpen}
          onClose={() => {
            setIsErrorMessageModalOpen(false);
            history.push(PAGES.BASE);
          }}
          errorMessage={errorMessage}
          redirect={() => {
            setIsErrorMessageModalOpen(false);
            history.push(PAGES.BASE);
          }}
        />
      )}
    </EmptyPage>
  );
};

export default SalesAssistedInviteUser;
